import { API_BASE_URL } from '../../../api';
import React, { useEffect, useContext, useState } from "react";
import "./layout.style.scss";
import Sidebar from "../SideBar/sideBar.component";
import NavBar from "../NavBar/navbar.component";
import { AccountContext } from "../../../Contexts/main.context";
import TheOutlet from "../TheOutlet/theOutlet.component";
import { useNavigate } from "react-router-dom";




const Layout = () => {

     const {googleCategories,updateGoogleCategories,userAccounts, updateUserAccounts, clientAccounts, updateClientAccounts,myAccount } = useContext(AccountContext);
     // eslint-disable-next-line
     const [actionButtons, setActionButtons] = useState([]);
     const navigate = useNavigate();
     const [accountLoadError, setAccountLoadError] = useState(null);



     const fetchAccounts = async () => {
          try {
               const response = await fetch(API_BASE_URL + 'data.php', {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ script: "getAccounts" }) // or "getAccounts"
               });

               if (!response.ok) {
                    throw new Error("Failed to fetch accounts");
               }
               const data = await response.json();
               if (!Array.isArray(data)) throw new Error('The server returned an invalid list.');
               return data;

               // Example: setAccounts(data); if using useState
          } catch (error) {
               console.error("Error fetching accounts:", error);
          }
     };


     const fetchUsers = async () => {
          try {
               const response = await fetch(API_BASE_URL + 'data.php', {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ script: "getUsers" }) // or "getAccounts"
               });

               if (!response.ok) {
                    throw new Error("Failed to fetch accounts");
               }

               const data = await response.json();
               if (!Array.isArray(data)) throw new Error('The server returned an invalid list.');
               return data;

               // Example: setAccounts(data); if using useState
          } catch (error) {
               console.error("Error fetching accounts:", error);
          }
     };

     const fetchGoogle = async () => {
          try {
               const response = await fetch(API_BASE_URL + 'data.php', {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ script: "getCats" }) // or "getAccounts"
               });

               if (!response.ok) {
                    throw new Error("Failed to fetch accounts");
               }

               const data = await response.json();
               if (!Array.isArray(data)) throw new Error('The server returned an invalid list.');
               return data;

               // Example: setAccounts(data); if using useState
          } catch (error) {
               console.error("Error fetching accounts:", error);
          }
     };


     useEffect(() => {
          const getAccounts = async () => {
            if (clientAccounts.length === 0) {
              const clients = await fetchAccounts();
              if (Array.isArray(clients)) {
                updateClientAccounts(clients);
                setAccountLoadError(null);
              } else {
                setAccountLoadError('Unable to load client accounts. Please refresh to try again.');
              }
            }
          };
        
          const getUsers = async () => {
            if (userAccounts.length === 0) {
              const users = await fetchUsers();
              updateUserAccounts(users);
            }
          };

          const getCategories= async () => {
            if (googleCategories.length === 0) {
              const google = await fetchGoogle();
              updateGoogleCategories(google);
            }
          };

          getAccounts();
          getUsers();
          getCategories();
          // eslint-disable-next-line
        }, []);
        



     return (
          <div className="layout">
               <Sidebar />
               <div className="main">
                    {accountLoadError && <div className="alert alert-danger" role="alert">{accountLoadError}</div>}
                    <NavBar />
                    <TheOutlet />
               </div>
          </div>
     );
};

export default Layout;
